import { render, staticRenderFns } from "./EntityRawData.vue?vue&type=template&id=c255f968&scoped=true&"
import script from "./EntityRawData.vue?vue&type=script&lang=js&"
export * from "./EntityRawData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c255f968",
  null
  
)

export default component.exports